//泰语
export default {
	login: {
		salesBackend: "เข้าสู่ระบบระบบหลังบ้านการขาย OMELINK",
		account: "บัญชี",
		password: "รหัสผ่าน",
		login: "เข้าสู่ระบบ",
		pleaseEnter: "กรุณาใส่",
		userName: "ชื่อผู้ใช้",
		loginSuccessful: "เข้าสู่ระบบสำเร็จ",
		usingOa: "เข้าสู่ระบบโดยใช้บัญชี OA ของคุณ",
		usingSjfood: "เข้าสู่ระบบโดยใช้บัญชี HiFood ของคุณ",
	},
	index: {
		customerSettings: "การตั้งค่าลูกค้า",
		personalInformation: "ข้อมูลส่วนบุคคล",
		logOut: "ออกจากระบบ",
		selectLanguage: "เลือกภาษา",
		confirmExit: "ยืนยันการออก?",
		hint: "คำแนะนำ",
		productSettings: "การตั้งค่าสินค้า",
		syncSettings: "การตั้งค่าซิงค์",
		customerBinding: "การผูกลูกค้า",
	},
	personal: {
		avatar: "รูปโปรไฟล์",
		nickName: "ชื่อเล่น",
	},
	operator: {
		addTo: "เพิ่มไปยัง",
		authorizer: "ผู้อนุญาต",
		permissions: "สิทธิ์",
		startingTime: "เวลาเริ่มต้น",
		endTime: "เวลาสิ้นสุด",
		revise: "แก้ไข",
		delete: "ลบ",
		viewPermissions: "ดูสิทธิ์, ส่งสิทธิ์",
	},
	customer: {
		customerCode: "รหัสลูกค้า",
		customerName: "ชื่อลูกค้า",
		warehouse: "คลังสินค้า",
		customerBindingQuantity: "จำนวนการผูกลูกค้า",
		maintenanceQuantity: "จำนวนการบำรุงรักษาการเปลี่ยนแปลงวัสดุ",
		operate: "ดำเนินการ",
		customerBinding: "การผูกลูกค้า",
		productSettings: "การตั้งค่าสินค้า",
		batchOpertion: "การบำรุงรักษาแบบกลุ่ม",
		selectCustomer: "เลือกลูกค้า",
		importItem: "นำเข้ารายการ",
		batchImportItem: "นำเข้ารายการแบบกลุ่ม",
		successfully: "เสร็จสิ้น",
		previousStep: "ขั้นตอนก่อนหน้า",
		nextStep: "ขั้นตอนถัดไป",
		selectFile: "เลือกไฟล์",
		templateDownload: "ดาวน์โหลดเทมเพลต",
		noFileSelected: "ยังไม่ได้เลือกไฟล์",
		downloadingTemplate: "ดาวน์โหลดเทมเพลตสำเร็จ",
		operationSuccess: "บำรุงรักษาแบบกลุ่มสำเร็จ",
		aTotalOf: "ทั้งหมด",
		errorTips: "รายการระบบตรวจพบข้อผิดพลาด ID การนำเข้าไม่สำเร็จ! กรุณาตรวจสอบและลองอีกครั้ง",
		importSuccessfully: "นำเข้าสำเร็จ",
	},
	customerProduct: {
		myClient: "ลูกค้าของฉัน",
		productSettings: "การตั้งค่าสินค้า",
		specification: "รายละเอียด",
		editedSuccessfully: "แก้ไขสำเร็จ!",
	},
	customerProductLastest: {
		myClient: "ลูกค้าของฉัน",
		productSettings: "การตั้งค่าสินค้า",
		syncSettings: "การตั้งค่าซิงค์",
		changeUpdates: "ตรวจสอบการเปลี่ยนแปลงสินค้า",
		old: "เก่า",
		new: "ใหม่",
		state: "สถานะ",
		waitingForConfirmation: "รอการยืนยัน",
		applied: "นำไปใช้แล้ว",
		notApplied: "ยังไม่ได้นำไปใช้",
		operate: "ดำเนินการ",
		newAdditions: "เพิ่มใหม่",
		renew: "ต่ออายุ",
		time: "เวลา",
		SALESConfirmed: "ยืนยันโดย SALES",
		application: "การสมัคร",
		notApplied: "ยังไม่ได้นำไปใช้",
		successfulOperation: "ดำเนินการสำเร็จ!",
	},
	customerPhone: {
		myClient: "ลูกค้าของฉัน",
		customerBinding: "การผูกลูกค้า",
		addBinding: "เพิ่มการผูก",
		noData: "ไม่มีข้อมูล กรุณาเพิ่ม",
		telephoneNumber: "หมายเลขโทรศัพท์",
		remarkName: "ชื่อหมายเหตุ",
		memorandum: "บันทึกช่วยจำ",
		smsDisable: "ปิดใช้งาน SMS",
		operate: "ดำเนินการ",
		edit: "แก้ไข",
		unbind: "ยกเลิกการผูก",
		CRMContact: "เลือกผู้ติดต่อ CRM",
		enterANote: "ใส่บันทึก",
		editBinding: "แก้ไขการผูก",
		correctPhoneNumber: "กรุณาใส่รูปแบบหมายเลขโทรศัพท์ที่ถูกต้อง",
		ContentIsTooLong: "กรุณาใส่บันทึกช่วยจำ",
		bindingSuccessfully: "เพิ่มการผูกสำเร็จ!",
		errorMessage: "ข้อมูลที่กรอกมีข้อผิดพลาด!",
		successfulOperation: "ดำเนินการสำเร็จ!",
		setupSuccessful: "ตั้งค่าสำเร็จ!",
		closedSuccessfully: "ปิดสำเร็จ!",
		unbindHint: "ยืนยันที่จะยกเลิกการผูก?",
		hint: "คำแนะนำ",
		UnbindingSuccessful: "ยกเลิกการผูกสำเร็จ!",
		numberIdentityNote: "หมายเลข, ตัวตน, หมายเหตุ",
		selectIdentityNote: "เลือกหมายเหตุตัวตน",
		customRemarks: "หมายเหตุหมายเลขตัวตนที่กำหนดเอง",
		pleaseEnterCustomRemarks: "กรุณาใส่หมายเหตุหมายเลขตัวตนที่กำหนดเอง",
		manager: "ผู้จัดการ",
		boss: "เจ้านาย",
		headChef: "หัวหน้าเชฟ",
		accountant: "นักบัญชี",
		custom: "กำหนดเอง",
		phoneEditDelateGuid: "ไม่สามารถดำเนินการกับผู้ติดต่อจาก CRM ได้ กรุณาดำเนินการใน CRM",
		billManagement: "การจัดการการชำระเงิน",
		add: "เพิ่มใหม่",
	},
	productSpecification: {
		addTo: "เพิ่มไปยัง",
		nameSearch: "ใส่ชื่อรายละเอียดเพื่อค้นหา",
		specificationName: "ชื่อรายละเอียด",
		operate: "ดำเนินการ",
		edit: "แก้ไข",
		editSpecifications: "แก้ไขรายละเอียด",
		attributes: "คุณสมบัติ",
		addAttributes: "กรุณาเพิ่มคุณสมบัติ",
		name: "ชื่อ",
		optionName: "ใส่ชื่อตัวเลือก",
		enterSpecificationName: "กรุณาใส่ชื่อรายละเอียด!",
		addOptions: "กรุณาเพิ่มตัวเลือก!",
		editedSuccessfully: "แก้ไขสำเร็จ!",
		errorMessage: "ข้อมูลที่กรอกมีข้อผิดพลาด!",
		enterAttributeName: "ใส่ชื่อคุณสมบัติ",
		sureDelete: "ยืนยันที่จะลบ?",
		hint: "คำแนะนำ",
		successfullyDeleted: "ลบสำเร็จ!",
		cannotSortWhenSearching: "ไม่สามารถจัดเรียงได้ในขณะค้นหา",
		sortingSaveFail: "จัดเรียงบันทึกไม่สำเร็จ",
		sortingSaveSuccess: "จัดเรียงบันทึกสำเร็จ",
	},
	productHistory: {
		materialChange: "การบำรุงรักษาการเปลี่ยนแปลงวัสดุ",
		aliasSearch: "ใส่ชื่อสินค้าหรือชื่อเล่นเพื่อค้นหา",
		noData: "ไม่มีข้อมูล",
		productName: "ชื่อสินค้า",
		productAlias: "ชื่อเล่นสินค้า",
		category: "หมวดหมู่",
		state: "สถานะ",
		enable: "เปิดใช้งาน",
		disable: "ปิดใช้งาน",
		operate: "ดำเนินการ",
		edit: "แก้ไข",
		codingImportGoods: "นำเข้าสินค้าด้วยรหัสลูกค้า",
		importProducts: "นำเข้าสินค้า",
		enterCustomerCode: "ใส่รหัสลูกค้า",
		selectProduct: "เลือกสินค้า",
		finish: "เสร็จสิ้น",
		customerCode: "รหัสลูกค้า",
		nextStep: "ขั้นตอนต่อไป",
		cancelSelection: "ยกเลิกการเลือก",
		previous: "ก่อนหน้า",
		import: "นำเข้า",
		aTotalOf: "ทั้งหมด ",
		productImportSuccess: "สินค้านำเข้าสำเร็จ",
		productImportFailure: "สินค้าถูกระบบตรวจพบว่าซ้ำกันและนำเข้าไม่สำเร็จ! กรุณาตรวจสอบก่อนนำเข้า",
		pleaseEnterCustomerCode: "กรุณาใส่รหัสลูกค้า!",
		messageInformationCorrectly: "กรุณากรอกข้อมูลให้ถูกต้อง!",
		pleaseSelectProduct: "กรุณาเลือกข้อมูลสินค้าที่ต้องการนำเข้า!",
	},
	productEdit: {
		editProductInformation: "แก้ไขข้อมูลสินค้า",
		basicInformation: "ข้อมูลพื้นฐาน",
		productName: "ชื่อสินค้า",
		productAlias: "ชื่อเล่นสินค้า",
		category: "หมวดหมู่",
		state: "สถานะ",
		enable: "เปิดใช้งาน",
		disable: "ปิดใช้งาน",
		specificationInformation: "ข้อมูลรายละเอียด",
		selectSpecifications: "เลือกรายละเอียด",
		deleteSpecification: "ลบรายละเอียด",
		enterSpecificationName: "ใส่ชื่อรายละเอียด",
		addSpecs: "เพิ่มรายละเอียด",
		pleaseChoose: "กรุณาเลือก",
		attributes: "คุณสมบัติ",
	},
	productAll: {
		aliasSearch: "ใส่ชื่อสินค้าหรือชื่อเล่นเพื่อค้นหา",
		noData: "ไม่มีข้อมูล",
		productName: "ชื่อสินค้า",
		productAlias: "ชื่อเล่นสินค้า",
		category: "หมวดหมู่",
		state: "สถานะ",
		enable: "เปิดใช้งาน",
		disable: "ปิดใช้งาน",
		operate: "ดำเนินการ",
		edit: "แก้ไข",
		insert: "แทรก",
		insertingSuccessfully: "แทรกประวัติสำเร็จ!",
	},
	avatar: {
		setAvatar: "ตั้งค่ารูปโปรไฟล์",
		preview: "ดูตัวอย่าง",
		changePicture: "เปลี่ยนรูปภาพ",
		enlarge: "ขยาย",
		zoomOut: "ย่อ",
		rotateLeft: "หมุนซ้าย",
		rotateRight: "หมุนขวา",
		upload: "อัปโหลด",
		errorGetAvatar: "ไม่สามารถรับรูปโปรไฟล์ได้ กรุณาลองใหม่ในภายหลัง",
		sizeCannotExceed: "ขนาดรูปภาพโปรไฟล์ที่อัปโหลดต้องไม่เกิน 2MB!",
		selectPicture: "เลือกรูปภาพ",
		setupSuccessful: "ตั้งค่าสำเร็จ",
		uploadFailed: "อัปโหลดไม่สำเร็จ กรุณาลองใหม่ในภายหลัง",
	},
	addSpecification: {
		addSpecs: "เพิ่มรายละเอียด",
		specificationName: "ชื่อรายละเอียด",
		attributes: "คุณสมบัติ",
		addAttributes: "กรุณาเพิ่มคุณสมบัติ",
		addTo: "เพิ่มไปยัง",
		name: "ชื่อ",
		operate: "ดำเนินการ",
		delete: "ลบ",
		addProperties: "เพิ่มคุณสมบัติ",
		enterAttributeName: "ใส่ชื่อคุณสมบัติ",
		enterSpecificationName: "ใส่ชื่อรายละเอียด!",
		addOptions: "เพิ่มตัวเลือก",
		addedSuccessfully: "เพิ่มสำเร็จ!",
		errorMessage: "ข้อมูลที่กรอกมีข้อผิดพลาด!",
	},
	chatEmojiPicker: {
		recent: "ล่าสุด",
		people: "คน",
		nature: "ธรรมชาติ",
		foods: "อาหาร",
		activity: "กิจกรรม",
		places: "สถานที่",
		objects: "วัตถุ",
		symbols: "สัญลักษณ์",
		flags: "ธง",
	},
	chatHistoryMessage: {
		viewContext: "ดูเนื้อหา",
		copy: "คัดลอก",
		save: "บันทึก",
		copiedToClipboard: "คัดลอกไปยังคลิปบอร์ดแล้ว",
		copyFailed: "คัดลอกไม่สำเร็จ",
		errorTextMessage: "รองรับการคัดลอกข้อความเท่านั้นในขณะนี้",
		errorMessage: "รองรับการบันทึกข้อความเสียงเท่านั้นในขณะนี้",
	},
	chatHistory: {
		enterChatContent: "ใส่เนื้อหาการแชท",
		back: "ย้อนกลับ",
	},
	chatMessageCheckDetails: {
		serialNumber: "หมายเลขซีเรียล",
		amount: "จำนวน",
		uploadDate: "วันที่อัปโหลด",
		frontPicture: "รูปด้านหน้าของเช็ค",
		reversePicture: "รูปด้านหลังของเช็ค",
		supplier: "ผู้จัดหา",
		userAmount: "จำนวนที่ผู้ใช้ป้อน",
		checkStatus: "สถานะการตรวจสอบ",
	},
	chatMessageCheck: {
		checkUploadReminder: "การแจ้งเตือนการอัปโหลดเช็ค",
		checkCheckUpload: "ตรวจสอบการอัปโหลดเช็ค",
		checkDetails: "รายละเอียดการตรวจสอบ",
	},
	chatMessageNonsupport: {
		versionIsTooLow: "เวอร์ชันของคุณต่ำเกินไปที่จะดูเนื้อหานี้",
	},
	chatMessageOrder: {
		orderDetails: "รายละเอียดคำสั่งซื้อ",
		order: "คำสั่งซื้อ",
		deliveryDate: "วันที่จัดส่ง",
		productsOrdered: "สินค้าที่สั่งซื้อ",
		productsInclude: "สินค้ารวมถึง",
		viewOrder: "ดูคำสั่งซื้อ",
	},
	chatMessageReplenishment: {
		title: "เติมสินค้าอัจฉริยะ",
		deliveryDate: "วันที่จัดส่ง",
		items: "จำนวน ITEM",
		confirming: "รอการยืนยัน",
		expired: "หมดอายุ",
		confirmed: "ยืนยันโดย {name}",
	},
	chatMessageReadStatus: {
		haveRead: "อ่านแล้ว",
		unread: "ยังไม่อ่าน",
		readingStatus: "สถานะการอ่าน",
	},
	chatMessageStatus: {
		resendThisMessage: "ส่งข้อความนี้อีกครั้ง?",
		hint: "คำแนะนำ",
	},
	chatMessageText: {
		translateText: "แปลข้อความ",
	},
	chatMessageVoice: {
		voiceIsCorrupted: "เสียงเสียหาย",
	},
	chatMessages: {
		retractedMessage: "คุณได้ถอนข้อความ",
		copy: "คัดลอก",
		save: "บันทึก",
		recall: "เรียกคืน",
		concealTranslated: "ซ่อนการแปล",
		translated: "แปลแล้ว",
		copiedToClipboard: "คัดลอกไปยังคลิปบอร์ดแล้ว",
		copyFailed: "คัดลอกไม่สำเร็จ",
		supportsTextMessages: "รองรับการคัดลอกข้อความเท่านั้นในขณะนี้",
		supportsTextVoice: "รองรับการบันทึกข้อความเสียงเท่านั้นในขณะนี้",
		supportsTexttranslated: "รองรับการแปลข้อความเท่านั้นในขณะนี้",
	},
	chatPicturePaster: {
		sendThisImage: "ส่งรูปภาพนี้?",
		send: "ส่ง",
	},
	chatRecorder: {
		recording: "กำลังบันทึก",
		stop: "หยุด",
		send: "ส่ง",
		recordingFailed: "บันทึกไม่สำเร็จ",
		timeShort: "เวลาพูดสั้นเกินไป",
		timeLong: "เวลาพูดยาวเกินไป",
		microphonePermissionDenied: "การบันทึกเสียงล้มเหลว กรุณาอนุญาตการเข้าถึงไมโครโฟน",
	},
	contactList: {
		remarkName: "ชื่อหมายเหตุ:",
	},
	contacts: {
		contactPerson: "บุคคลติดต่อ",
	},
	conversationList: {
		recentChat: "การแชทล่าสุด",
		remarkName: "ชื่อหมายเหตุ:",
		cancelStick: "ยกเลิกการปักหมุด",
		haveRead: "อ่านแล้ว",
		unread: "ยังไม่อ่าน",
		stick: "ปักหมุด",
		pinnedSuccessfully: "ปักหมุดสำเร็จ!",
		unpinnedSuccessfully: "ยกเลิกการปักหมุดสำเร็จ!",
	},
	detailContact: {
		chatInformation: "ข้อมูลการแชท",
		METISusageCount: "จำนวนการใช้ METIS:",
		leftOver: "เหลือ",
		strip: "แถบ",
		nickName: "ชื่อเล่น",
		remarkName: "ชื่อหมายเหตุ",
		revise: "แก้ไข",
		associatedCustomers: "ลูกค้าที่เกี่ยวข้อง",
		none: "ไม่มี",
		smartResponse: "บริการลูกค้า METIS แบบตอบสนองอัจฉริยะ",
		open: "เปิด",
		close: "ปิด",
		automaticTranslation: "การแปลอัตโนมัติ",
		setupSuccessful: "ตั้งค่าสำเร็จ!",
		enterRemarks: "ใส่หมายเหตุ",
		hint: "คำแนะนำ",
		yes: "ใช่",
		no: "ไม่",
		phoneNumber: "หมายเลขโทรศัพท์",
		openTip1: "PST 13:30 - วันถัดไป PST 01:00",
		openTip2: "ในช่วงเวลานี้ หากความตั้งใจของคำถามลูกค้าถูกระบุว่าเป็นปัญหาที่ทราบแล้ว METIS จะตอบกลับตามปกติ",
		openTip3: "ในช่วงเวลานี้ หากความตั้งใจของคำถามลูกค้าถูกระบุว่าเป็นปัญหาที่ยังไม่ทราบ METIS จะไม่ตอบกลับ",
		userDoesNotBelong: "ผู้ใช้ปัจจุบันไม่ใช่ผู้ติดต่อของคุณ",
	},
	detailGroup: {
		groupInformation: "ข้อมูลกลุ่ม",
		groupChatName: "ชื่อกลุ่มแชท:",
		modifyGroupName: "แก้ไขชื่อกลุ่ม",
		addMember: "เพิ่มสมาชิก",
		noData: "ไม่มีข้อมูล กรุณาเพิ่ม",
		avatar: "รูปโปรไฟล์",
		nickName: "ชื่อเล่น",
		groupOwner: "เจ้าของกลุ่ม",
		groupNotes: "หมายเหตุกลุ่ม",
		operate: "ดำเนินการ",
		editorNotes: "แก้ไขหมายเหตุ",
		removeMember: "ลบสมาชิก",
		userDoesNotBelong: "ผู้ใช้ปัจจุบันไม่อยู่ในกลุ่มนี้!",
		enterTheCommentName: "ใส่ชื่อหมายเหตุของสมาชิก",
		hint: "คำแนะนำ",
		selectMembers: "เลือกสมาชิก",
		pleaseEnterTheGroupChatName: "กรุณาใส่ชื่อกลุ่มแชท",
		groupNameHasNotChanged: "ชื่อกลุ่มยังไม่เปลี่ยนแปลง!",
		groupNameCannotBeEmpty: "ชื่อกลุ่มไม่สามารถว่างได้!",
		confirmToRemoveMember: "ยืนยันการลบสมาชิก?",
	},
	groupList: {
		groupChat: "กลุ่มแชท",
		createGroupChat: "สร้างกลุ่มแชท",
		groupName: "ชื่อกลุ่ม:",
	},
	selectMember: {
		selectMembers: "เลือกสมาชิก",
		chosen: "เลือกแล้ว:",
		contactPerson: "บุคคลติดต่อ",
		salesperson: "พนักงานขาย",
		groupChat: "กลุ่มแชทของ",
		atLeast: "ต้องการสมาชิกอย่างน้อย 3 คนสำหรับกลุ่มแชท",
	},
	chat: {
		realTimeServer: "การเชื่อมต่อเซิร์ฟเวอร์เรียลไทม์ล้มเหลว กำลังเชื่อมต่อ...",
		enterSearchContent: "ใส่เนื้อหาการค้นหา",
		recentChat: "การแชทล่าสุด",
		addressBook: "สมุดที่อยู่",
		groupChat: "กลุ่มแชท",
		chatRecord: "บันทึกการแชท",
		selectLanguage: "เลือกภาษา",
		ctrlEnter: "กด Ctrl + Enter เพื่อส่งข้อความ",
		commandEnter: "กด Command + Enter เพื่อส่งข้อความ",
		enter: "กด Enter เพื่อส่งข้อความ",
		translateContent: "แปลเนื้อหา",
		send: "ส่ง",
		imageUploadFailed: "อัปโหลดรูปภาพไม่สำเร็จ กรุณาลองอีกครั้ง",
		onlyWithdrawMessages: "คุณสามารถถอนข้อความของคุณเองเท่านั้น",
		fileError: "ไม่สามารถอ่านข้อมูลไฟล์วิดีโอได้!",
		loadFailed: "โหลดไม่สำเร็จ คลิกเพื่อลองอีกครั้ง",
		loading: "กำลังโหลด...",
		fileErrorTip: "ส่งล้มเหลว รูปแบบไฟล์รองรับรูปภาพหรือ MP4 ขนาดไฟล์ไม่เกิน 300MB และระยะเวลาไฟล์ไม่เกิน 30 นาที",
		aFile: "ไฟล์",
		errprTip: "การอัปโหลดไฟล์ล้มเหลว ไม่สามารถส่งใหม่ได้ โปรดเลือกไฟล์อีกครั้งเพื่ออัปโหลด",
	},
	messageJS: {
		voice: "[เสียง]",
		picture: "[รูปภาพ]",
	},
	storeIndexJS: {
		have: "มี",
		unreadMessages: "ข้อความที่ยังไม่อ่าน",
		haveNewMessage: "คุณมีข้อความใหม่",
	},
	apiJS: {
		loginHasExpired: "การเข้าสู่ระบบหมดอายุแล้ว ต้องการเข้าสู่ระบบอีกครั้งหรือไม่?",
		hint: "คำแนะนำ",
		unknownMistake: "ข้อผิดพลาดที่ไม่ทราบสาเหตุ",
	},
	sessionLock: {
		idleTimeout: "เซสชันของคุณถูกล็อกเนื่องจากไม่มีการใช้งานเป็นเวลานาน กรุณาเข้าสู่ระบบอีกครั้ง",
	},
	router: {
		login: "เข้าสู่ระบบ",
		customerCommunication: "การสื่อสารกับลูกค้า",
		setup: "ตั้งค่า",
		myClient: "ลูกค้าของฉัน",
		customerBinding: "การผูกลูกค้า",
		productSettings: "การตั้งค่าสินค้า",
		syncSettings: "การตั้งค่าซิงค์",
		personalInformation: "ข้อมูลส่วนบุคคล",
		authorizationSettings: "การตั้งค่าการอนุญาต",
		messageSending: "การส่งข้อความ",
		aiEmail: "AI EMAIL设置",
		openClawManagement: "จัดการพนักงานดิจิทัล",
		omelinkUserServiceMaintenance: "OMELINK การบำรุงรักษาบริการผู้ใช้",
	},
	dateJS: {
		today: "วันนี้",
	},
	common: {
		cancel: "ยกเลิก",
		confirm: "ยืนยัน",
		sure: "แน่นอน",
		delete: "ลบ",
		options: "ตัวเลือก",
		option: "ตัวเลือก",
		history: "ประวัติ",
		all: "ทั้งหมด",
		setup: "ตั้งค่า",
	},
	chatMessageOrderDetails: {
		supplier: "ผู้จัดหา",
		orderBy: "สั่งโดย",
		billTo: "ออกบิลให้",
		shipTo: "จัดส่งถึง",
		deliveryDate: "วันที่จัดส่ง",
		comment: "ความคิดเห็น",
		ordered: "สั่งแล้ว",
		include: "รวมถึง",
		orderDetails: "รายละเอียดการสั่งซื้อ",
	},
	generalization: {
		listTitle: "รายการโปรโมท",
		searchPlaceholder: "ค้นหา",
		checkOut: "ดูรายละเอียด",
		sendAgain: "ส่งอีกครั้ง",
		send: "ส่งทันที",
		detailTitle: "รายละเอียดโปรโมท",
		isSendMessage: "ส่งข้อความให้",
	},
	messageSending: {
		title: "ลูกค้าที่ยังไม่ได้ลงทะเบียนกับ OMELINK",
		customerName: "ชื่อลูกค้า",
		customerPhone: "โทรศัพท์ลูกค้า",
		associatedRestaurantId: "ID ร้านอาหารที่เชื่อมโยง",
		restaurantName: "ชื่อร้านอาหาร",
		operate: "การดำเนินการ",
		historyRecord: "ประวัติการบันทึก",
		sendMessage: "ส่งข้อความ SMS",
		cancel: "ยกเลิก",
		confirm: "ยืนยันการส่ง",
		restaurantId: "ID ร้านอาหาร",
		close: "ปิด",
		orderId: "ID คำสั่ง",
		snedText: "เนื้อหาที่ส่ง",
		sendTime: "เวลาที่ส่ง",
		sendSuccess: "ส่งสำเร็จ",
		isCheckedDocument: "ดูเอกสารไหม",
		isDownLoad: "ดาวน์โหลด OMELINK ไหม",
		sendDocument: "ส่งเอกสาร",
		true: "ใช่",
		false: "ไม่",
		check: "ดู",
	},
	aiEmail: {
		account: "บัญชีอีเมล",
		accountDescription: "ตั้งค่ากล่องจดหมายที่ใช้รับและประมวลผลอีเมลคำสั่งซื้อด้วย AI",
		configureAccount: "ตั้งค่าอีเมล",
		editAccount: "แก้ไขอีเมล",
		emailAddress: "ที่อยู่อีเมล",
		emailPassword: "รหัสผ่านอีเมล",
		passwordSetHint: "ได้ตั้งรหัสผ่านแล้ว เว้นว่างไว้เพื่อคงรหัสผ่านเดิม",
		accountEnabled: "เปิดใช้การประมวลผลอีเมล",
		enabled: "เปิดใช้งาน",
		disabled: "ปิดใช้งาน",
		syncError: "ข้อผิดพลาดในการซิงค์",
		latestSync: "ซิงค์ล่าสุด",
		noSyncTime: "ไม่มีข้อมูล",
		accountEmpty: "ยังไม่ได้ตั้งค่าบัญชีอีเมล โปรดบันทึกอีเมลและรหัสผ่านเพื่อเริ่มต้น",
		emailDisabledNotice: "บัญชีอีเมลนี้ถูกปิดใช้งาน อีเมลจะไม่ถูกซิงค์หรือประมวลผล แต่ยังจัดการผู้ติดต่อได้",
		contacts: "ผู้ติดต่อทางอีเมล",
		contactsDescription: "AI จะประมวลผลเฉพาะอีเมลคำสั่งซื้อจากผู้ติดต่อที่ตั้งค่าไว้เท่านั้น",
		addContact: "เพิ่มผู้ติดต่อ",
		editContact: "แก้ไขผู้ติดต่อ",
		guestEmail: "อีเมลลูกค้า",
		processingMode: "โหมดการประมวลผล",
		automatic: "อัตโนมัติเต็มรูปแบบ",
		semiAutomatic: "กึ่งอัตโนมัติ",
		automaticDescription: "AI จะตอบลูกค้าเป็นภาษาอังกฤษและสร้างคำสั่งซื้อเมื่อข้อมูลครบถ้วน",
		semiAutomaticDescription: "AI จะระบุเจตนาการสั่งซื้อแบบเงียบ ๆ และสร้างคำสั่งซื้อโดยไม่ตอบลูกค้า",
		associatedCustomers: "Customer ที่เชื่อมโยง",
		updatedAt: "อัปเดตเมื่อ",
		actions: "การดำเนินการ",
		edit: "แก้ไข",
		delete: "ลบ",
		customerPlaceholder: "เลือก Customer",
		noCustomers: "ไม่มี Customer ที่ใช้ได้สำหรับพนักงานขายปัจจุบัน",
		loadingAccount: "กำลังโหลดการตั้งค่าอีเมล...",
		loadingContacts: "กำลังโหลดผู้ติดต่อ...",
		validatingConnection: "กำลังตรวจสอบการเชื่อมต่ออีเมล...",
		save: "บันทึก",
		accountSaveSuccess: "บันทึกการตั้งค่าอีเมลแล้ว",
		statusUpdateSuccess: "อัปเดตสถานะอีเมลแล้ว",
		contactCreateSuccess: "เพิ่มผู้ติดต่อแล้ว",
		contactUpdateSuccess: "อัปเดตผู้ติดต่อแล้ว",
		contactDeleteSuccess: "ลบผู้ติดต่อแล้ว",
		validationEmail: "โปรดป้อนที่อยู่อีเมลที่ถูกต้อง",
		validationPassword: "ต้องป้อนรหัสผ่านอีเมลเมื่อบันทึกบัญชีครั้งแรก",
		validationMode: "โปรดเลือกโหมดการประมวลผล",
		validationCustomers: "โปรดเลือก Customer อย่างน้อยหนึ่งรายการ",
		confirmDelete: "ยืนยันการลบ",
		deleteContactMessage: "หลังจากลบ ระบบจะไม่ประมวลผลอีเมลใหม่จาก {email} อีกต่อไป ต้องการลบผู้ติดต่อนี้หรือไม่?",
	},
	serviceMaintenance: {
		userList: "รายชื่อผู้ใช้งาน",
		serviceProviderList: "รายชื่อผู้ให้บริการ",
		customerName: "ชื่อลูกค้า",
		customerPhone: "เบอร์โทรศัพท์ลูกค้า",
		associatedRestaurantId: "รหัสภัตตาคารที่เกี่ยวข้อง",
		restaurantName: "ชื่อภัตตาคาร",
		operate: "ดำเนินการ",
		serviceMaintenance: "การดูแลรักษาผู้ให้บริการ",
		batchMaintenance: "การดูแลรักษาผู้ให้บริการแบบกลุ่ม",
		sort: "ลำดับ",
		applicationName: "ชื่อแอปพลิเคชัน",
		type: "ประเภท",
		status: "สถานะ",
		selectUsers: "เลือกผู้ใช้งาน",
		selectServiceProvider: "เลือกผู้ให้บริการ",
		complete: "เสร็จสิ้น",
		nextStep: "ขั้นตอนถัดไป",
		previous: "ย้อนกลับ",
		selectServiceProviderTip: "เลือกผู้ให้บริการที่ต้องการแสดง (ผู้ให้บริการที่ไม่ได้เลือกจะถูกปิดกั้น)",
		batchMaintenanceComplete: "การดูแลรักษากลุ่มเสร็จสมบูรณ์",
		latestShelvesTime: "เวลาอัปเดตล่าสุด",
		introduction: "คำแนะนำธุรกิจ",
		businessName: "ชื่อธุรกิจ",
		show: "แสดง",
		hide: "ซ่อน",
		soft: "ซอฟต์แวร์",
		service: "บริการ",
		successfulOperation: "ดำเนินการสำเร็จ!",
	},
	openClawManagement: {
		guestName: "ชื่อลูกค้า",
		guestPhoneNumber: "เบอร์โทรลูกค้า",
		associatedRestaurantId: "รหัสภัตตาคารที่เกี่ยวข้อง",
		restaurantName: "ชื่อภัตตาคาร",
		status: "สถานะพนักงานดิจิทัล",
		operate: "ดำเนินการ",
		show: "แสดง",
		hide: "ซ่อน",
		noData: "ไม่มีข้อมูล",
		loading: "กำลังโหลด...",
		updateSuccess: "ดำเนินการสำเร็จ!",
	},
};
